import { NavItem, NavLink } from 'reactstrap'
import classnames from 'classnames'
import './AppObjectTab.css'

export default function AppObjectTab({ object, action, tab, activeTab, setActiveTab }) {
  console.log(`AppObjectTab rendered: ${tab.name}`)
  return (
    <NavItem>
      <NavLink data-cy={`app-object-tab-${tab.name.toLowerCase().replace(/ /g, '-')}`} className={classnames('app-object-tab', { active: activeTab === tab.name })} onClick={() => { setActiveTab(tab.name) }}>{tab.name}</NavLink>
    </NavItem>
  )
}
